/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import {
	TabPanel,
	__experimentalDivider as Divider,
	__experimentalUnitControl as UnitControl,
	__experimentalNumberControl as NumberControl,
} from '@wordpress/components';
import { addFilter } from '@wordpress/hooks';

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import {
	ColorControl,
	GradientColorControl,
} from '../../../extensions/controls/color-options';
import { updateBlockStyle } from '../inline-styles';
import Accordion from '../../../components/Accordion';

const hookPrefix = `info-box`;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-style`,
	'Gutenify/Block/Info-Box/InspectorControls/BasicControls/tabs/style',
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { blockAdvanceOptions } = attributes;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'info-box',
						initialOpen: true,
						label: () => {
							return __( 'Info Box Style' );
						},
						cb: () => {
							return <>
								<TabPanel
									className="gutenify-editor-tab-panel gutenify-editor-tab-ovel"
									activeClass="active-tab"
									tabs={ [
										{
											name: 'normal',
											title: __( 'Normal' ),
											className: 'gutenify-color-normal-tab',
										},
										{
											name: 'hover',
											title: __( 'Hover' ),
											className: 'gutenify-color-hover-tab',
										},
									] }
								>
									{ ( tabInner ) => {
										return (
											<>
												{ 'normal' === tabInner.name && (
													<>
														<ColorControl
															label={ __( 'Color' ) }
															onChange={ ( color ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		textColor: color,
																	},
																};
																setAttributes( data );
																updateBlockStyle( data, props );
															} }
															value={ blockAdvanceOptions.textColor }
														/>
														<GradientColorControl
															label={ __( 'Background Color' ) }
															colorValue={ blockAdvanceOptions.backgroundColor }
															gradientValue={ blockAdvanceOptions.backgroundGradient }
															onChange={ ( val ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		...val,
																	},
																};
																setAttributes( data );
																updateBlockStyle( data, props );
															} }
														/>
														<ColorControl
															label={ __( 'Border Color' ) }
															onChange={ ( color ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		borderColor: color,
																	},
																};
																setAttributes( data );
																updateBlockStyle( data, props );
															} }
															value={ blockAdvanceOptions.borderColor }
														/>
													</>
												) }
												{ 'hover' === tabInner.name && (
													<>
														<ColorControl
															label={ __( 'Color' ) }
															onChange={ ( color ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		hoverTextColor: color,
																	},
																};
																setAttributes( data );
																updateBlockStyle( data, props );
															} }
															value={ blockAdvanceOptions.hoverTextColor }
														/>
														<GradientColorControl
															label={ __( 'Background Color' ) }
															colorValue={ blockAdvanceOptions.hoverBackgroundColor }
															gradientValue={
																blockAdvanceOptions.hoverBackgroundGradient
															}
															onChange={ ( val ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		...{
																			hoverBackgroundColor: val.backgroundColor,
																			hoverBackgroundGradient: val.backgroundGradient,
																		},
																	},
																};
																setAttributes( data );
																updateBlockStyle( data, props );
															} }
														/>
														<ColorControl
															label={ __( 'Border Color' ) }
															onChange={ ( color ) => {
																const data = {
																	blockAdvanceOptions: {
																		...blockAdvanceOptions,
																		hoverBorderColor: color,
																	},
																};
																setAttributes( data );
																updateBlockStyle( data, props );
															} }
															value={ blockAdvanceOptions.hoverBorderColor }
														/>
													</>
												) }
												<NumberControl
													label={ __( 'Border Width' ) }
													// help="Additional info about this."
													// beforeIcon={ arrowDown }
													// afterIcon={ arrowUp }
													// allowReset
													// resetFallbackValue={ 0 }
													// step={ 1 }
													// icon={ more }
													// separatorType="none"
													// isShiftStepEnabled
													value={ blockAdvanceOptions.borderWidth }
													onChange={ ( val ) => {
														const data = {
															blockAdvanceOptions: {
																...blockAdvanceOptions,
																borderWidth: val,
															},
														};
														setAttributes( data );
														updateBlockStyle( data, props );
													} }
													min={ 0 }
													max={ 300 }
													// withInputField={ true }
												/>

												<UnitControl
													label={ __( 'Border Radius' ) }
													value={ blockAdvanceOptions.borderRadius }
													onChange={ ( val ) => {
														const data = {
															blockAdvanceOptions: {
																...blockAdvanceOptions,
																borderRadius: val,
															},
														};
														setAttributes( data );
														updateBlockStyle( data, props );
													} }
													min={ 0 }
													max={ 300 }
													// withInputField={ true }
												/>
												<Divider />
											</>
										);
									} }
								</TabPanel>
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);

